module.exports = __webpack_public_path__ + "static/media/logo_faan.89243a01.png";